import type { TrigKey } from './keys';

export const ar: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'الرياضيات · حساب المثلثات',
  'panel.experiment': 'تجربة',
  'panel.params': 'المعاملات',
  'panel.scene': 'اختر تجربة',
  'experiment.right-triangle.label': 'مثلث قائم الزاوية',
  'experiment.unit-circle.label': 'دائرة الوحدة',
  'experiment.wave-studio.label': 'استوديو الموجات',
  'experiment.identity-playground.label': 'متطابقات',
  'experiment.triangle-solver.label': 'حلّال المثلث',
  'experiment.circular-polar.label': 'دائري وقطبي',
  'hint.line1': 'اسحب النقاط وحرّك المنزلقات.',
  'hint.line2': 'المحتوى التعليمي يعيش في الهندسة لا في النص.',
  'rt.angle.a': 'الزاوية A',
  'rt.angle.b': 'الزاوية B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'راديان',
  'rt.show.sin': 'جا',
  'rt.show.cos': 'جتا',
  'rt.show.tan': 'ظا',
  'rt.snap': 'انجذاب لـ 30°/45°/60°',
  'uc.units': 'الوحدات',
  'uc.show.sin': 'جا',
  'uc.show.cos': 'جتا',
  'uc.show.tan': 'ظا',
  'uc.show.csc': 'قتا',
  'uc.show.sec': 'قا',
  'uc.show.cot': 'ظتا',
  'uc.show.astc': 'إظهار ASTC',
  'uc.snap.common': 'انجذاب للزوايا الشائعة',
  'uc.angle.value': '∠',
  'uc.units.deg': 'درجة',
  'uc.units.rad': 'رد',
  'uc.units.both': 'درجة+رد',
  'ws.fn': 'الدالة',
  'ws.fn.sin': 'جا',
  'ws.fn.cos': 'جتا',
  'ws.fn.tan': 'ظا',
  'ws.fn.csc': 'قتا',
  'ws.fn.sec': 'قا',
  'ws.fn.cot': 'ظتا',
  'ws.amplitude': 'A — السعة',
  'ws.frequency': 'B — التردد',
  'ws.phase': 'C — انزياح الطور',
  'ws.shift': 'D — انزياح رأسي',
  'ws.rform.toggle': 'اشتقاق صيغة R',
  'ws.rform.a': 'a (معامل جا)',
  'ws.rform.b': 'b (معامل جتا)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'إعادة',
  'ws.base': 'إظهار المنحنى الأساسي',
  'ip.id.pythagorean': 'فيثاغورية',
  'ip.id.reciprocal': 'متبادلة',
  'ip.id.quotient': 'القسمة',
  'ip.id.sum': 'الجمع',
  'ip.id.difference': 'الفرق',
  'ip.id.double': 'ضعف الزاوية',
  'ip.id.half': 'نصف الزاوية',
  'ip.play': 'تشغيل',
  'ip.pause': 'إيقاف',
  'ip.step': 'خطوة',
  'ip.reset': 'إعادة',
  'ip.proof.pythagorean.summary': 'جا²θ + جتا²θ = 1',
  'ip.proof.reciprocal.summary': 'قتا θ = 1/جا θ،  قا θ = 1/جتا θ،  ظتا θ = 1/ظا θ',
  'ip.proof.quotient.summary': 'ظا θ = جا θ / جتا θ',
  'ip.proof.sum.summary': 'جا(A+B) = جا A جتا B + جتا A جا B',
  'ip.proof.difference.summary': 'جا(A−B) = جا A جتا B − جتا A جا B',
  'ip.proof.double.summary': 'جا 2θ = 2 جا θ جتا θ',
  'ip.proof.half.summary': 'جا(θ/2) = ±√((1 − جتا θ)/2)',
  'ip.proof.v2.note': 'في v2 — يحتاج البرهان لبناء أعقد.',
  'ts.area': 'المساحة',
  'ts.sineRule': 'قانون الجيوب',
  'ts.cosineRule': 'قانون جيوب التمام',
  'ts.ambiguous.toggle': 'إظهار مثلث الشبح عند الالتباس',
  'ts.reset': 'إعادة لمتساوي الأضلاع',
  'ts.snap.integers': 'انجذاب لأعداد صحيحة',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'الأضلاع',
  'ts.section.angles': 'الزوايا',
  'ts.section.sineRule': 'قانون الجيوب',
  'ts.section.cosineRule': 'قانون جيوب التمام',
  'ts.section.area': 'المساحة',
  'cp.omega': 'السرعة الزاوية',
  'cp.plot.y': 'رسم y (جا)',
  'cp.plot.x': 'رسم x (جتا)',
  'cp.polar.label': 'شكل قطبي',
  'cp.polar.circle': 'دائرة (r = 1)',
  'cp.polar.rose': 'وردة (r = جا 3θ)',
  'cp.polar.cardioid': 'قلبية (r = 1 + جتا θ)',
  'cp.polar.limacon': 'ليماسون (r = 1 − 2 جتا θ)',
  'cp.smallAngle': 'تقريب الزاوية الصغيرة (جا x ≈ x)',
  'cp.play': 'تشغيل',
  'cp.pause': 'إيقاف',
  'cp.reset': 'إعادة',
  'cp.step': 'خطوة π/12',
};
